<template>
  <div class="registerStepConBox">
    <div class="stepCon">
      <div class="chioseBackBox">
        <div class="headBox">
          <img
            class="promptIcon"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051217565519446.svg"
            alt=""
          />
        </div>
        <div class="chioseConBox">
          <div class="titleBox">
            <div class="chioseTitleH1">
              {{ $fanyi("问卷填写完成！") }}
            </div>
            <div class="chioseTitleFont">
              {{ $fanyi("我们将会为您提供更具个性化的服务！") }}
            </div>
          </div>

          <el-button type="primary" class="ContinuarBtn" @click="goHome">{{
            $fanyi("开始")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ops from "../utils/opStore.js";
export default {
  data() {
    return { ops };
  },
  methods: {
    goBack() {
      this.ops.step--;
    },
    goHome() {
      this.$fun.routerToPage("/");
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
@import "../css/registerCss.scss";
.registerStepConBox {
  @extend .dip;
  width: 100%;
  padding-top: 0;
  padding-bottom: 0 !important;

  .stepCon {
    .chioseTitleFont {
      margin-bottom: 24px !important;
    }
  }
}

.ContinuarBtn {
  margin-top: 40px;
  margin-bottom: 0 !important;
}

.chioseConBox {
  padding-bottom: 0 !important;
}

.stepCon {
  transform: translateY(-15vh);
}
</style>
